import { createNumberFormat } from '@sunflower-games/number-format';
import i18n from 'i18next';

/**
 * German number format (PLT-49) lives in `@sunflower-games/number-format`; this app only supplies its live
 * language, read on every call so the output follows a language switch without a re-login.
 */
export const {
  isGermanNumberFormat,
  formatNumber,
  formatFixed,
  localizeDecimalSeparator,
  formatTypedAmount,
  acceptRawTypedAmount,
  acceptTypedAmount,
  withCurrencySymbol,
} = createNumberFormat(() => i18n.language);

export const formatMinRedeemAmount = (minAmount: number): string =>
  isGermanNumberFormat() ? withCurrencySymbol(localizeDecimalSeparator(String(minAmount)), '$') : `${minAmount}$`;

/**
 * For text that used to be written raw (`String(value)`, template literals): German format for DE, otherwise the
 * unchanged `String(value)`, so other languages keep exactly the output they had.
 */
export const formatPlainNumber = (value: number): string =>
  isGermanNumberFormat() ? formatNumber(value, { maximumFractionDigits: 20 }) : String(value);
